module.exports = __webpack_public_path__ + "img/Scarpa_BASSA_GRIGIO_DX.53fed95e.png";